import { Box, Flex, Button } from "rebass/styled-components";

const AboutStatic = ({ children, sx }) => (
  <Box
    px="3"
    sx={{
      bg: "lightYellow",
    }}
    id="about"
  >
    <Box maxWidth="792px" py={5} variant="intro">
      {children}
    </Box>
    <Box
      sx={{
        opacity: "0.2",
        width: "100%",
        height: "0px",
        borderBottomStyle: "solid",
        borderBottomWidth: "1px",
        borderBottomColor: "gold",
      }}
    ></Box>
  </Box>
);

export default AboutStatic;
